package com.eladfinish.bible.contest.screens.browse.usecases.chumash

import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesEnglish
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentUseCase
import com.eladfinish.bible.contest.utils.RegexUtils
import com.eladfinish.bible.contest.utils.gematriaWord
import io.github.aakira.napier.Napier

class GetParashaContentUseCase(
    private val getContentUseCase: GetContentUseCase,
) {

    operator fun invoke(
        input: String,
        bookIndex: Int,
        onlyQri: Boolean,
        isTikunKorim: Boolean = false,
    ): String {
        if (input.isEmpty()) {
            return ""
        }
        val pickedBookEng = bookNamesEnglish[bookIndex - 1]
        val matchResult = RegexUtils.getMatchResultOfParashaSource(input)

        val content = StringBuilder()
        matchResult?.let {

            // underscore is for the entire regex (ignored)
            val (_, startChapterOt, startVerseOt, endChapterOt, endVerseOt) =
                it.groups.map { group -> group!!.value }

            Napier.v("sourceRegex: $startChapterOt,$startVerseOt-$endChapterOt,$endVerseOt")

            val (_, startChapter, startVerse, endChapter, endVerse) =
                it.groups.map { group -> group!!.value.gematriaWord() }

            for (currentChapter in startChapter..endChapter) {
                content.append(
                    getContentUseCase.getContent(
                        bookIndex = bookIndex,
                        bookName = pickedBookEng,
                        currentChapter = currentChapter,
                        startVerseReferenceCV = VerseReferenceCV(chapter = startChapter, verse = startVerse),
                        endVerseReferenceCV = VerseReferenceCV(chapter = endChapter, verse = endVerse),
                        onlyQri = onlyQri,
                        isTikunKorim = isTikunKorim,
                    )
                ).append("\n")
            }
        }
        return content.toString().trim()
    }

}
